/**
 * Select with icon on the right side
 * Replaces chevron-down with custom icon
 */

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@shared/components/ui/select'
import { cn } from '@shared/lib/utils'
import type { LucideIcon } from 'lucide-react'

interface SelectWithIconProps {
  icon?: LucideIcon
  placeholder?: string
  value?: string
  onValueChange?: (value: string) => void
  options: { value: string; label: string }[]
  className?: string
  disabled?: boolean
}

export function SelectWithIcon({
  icon: Icon,
  placeholder,
  value,
  onValueChange,
  options,
  className,
  disabled,
}: SelectWithIconProps) {
  return (
    <div className="relative">
      <Select value={value} onValueChange={onValueChange} disabled={disabled}>
        <SelectTrigger className={cn(Icon && 'pr-10', className)}>
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>
        <SelectContent>
          {options.map((option) => (
            <SelectItem key={option.value} value={option.value}>
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      {Icon && (
        <div className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none">
          <Icon className="h-5 w-5 text-muted-foreground" />
        </div>
      )}
    </div>
  )
}
